import { Component, computed, input, output } from '@angular/core';
import { LanguageCodeHelper } from '@app/app/shared/helpers/language-code-helper';
import { CardUIType, LMS_PLATFORM_LABELS, PlaylistCardShort } from '@app/app/shared/models';
import { CheckmarkCircle02Icon, LinkSquare02Icon, Tick01Icon } from '@hugeicons/core-free-icons/index';
import { LucideCheck, LucideCircleCheck, LucideSquareArrowOutUpRight } from '@lucide/angular';

@Component({
  selector: 'ptl-card-item-snake-view',
  templateUrl: './card-item-snake-view.component.html',
  styleUrls: ['./card-item-snake-view.component.scss'],
})
export class CardItemSnakeViewComponent {
  protected readonly Tick01Icon = Tick01Icon;
  protected readonly CheckmarkCircle02Icon = CheckmarkCircle02Icon;
  protected readonly LinkSquare02Icon = LinkSquare02Icon;

  card = input<PlaylistCardShort>();
  cardIndex = input(0);
  cardType = input<CardUIType>('general');
  showImage = input(true);
  showMeta = input(true);
  showReviews = input(true);

  cardClick = output<PlaylistCardShort>();

  cardSubheader = computed(() => {
    const card = this.card();
    return card?.subHeader ? LanguageCodeHelper.getDataByLanguageCode(card.subHeader).value.trim() : '';
  });

  lmsPlatformLabel = computed(() => {
    const platformType = this.card()?.lmsPlatformType;
    return platformType ? LMS_PLATFORM_LABELS[platformType] || platformType : '';
  });

  onCardClick(): void {
    const card = this.card();
    if (card?.lmsCourseUrl) {
      window.open(card.lmsCourseUrl, '_blank', 'noopener,noreferrer');
    }
    this.cardClick.emit(card);
  }

  protected readonly LucideSquareArrowOutUpRight = LucideSquareArrowOutUpRight;
  protected readonly LucideCircleCheck = LucideCircleCheck;
  protected readonly LucideCheck = LucideCheck;
}
